export default __webpack_public_path__ + "static/media/img_logo_consultoria.51f4ed30.png";